export default {
	async mounted(store){
		app.store.commit('rms_ui/config/set_app_token',process.env.APP_JWT);
		await app.store.dispatch('rms_ui/auth/authInit', process.env.APP_JWT);
	}
}